// extracted by mini-css-extract-plugin
export default {"paymentSection":"H8-z"};